const items = [
  "DIGITAL SOVEREIGNTY",
  "THE FUTURE GUARDIAN",
  "IA",
  "OSINT",
  "PENTESTING",
  "SOC 24/7",
  "CIBERINTELIGENCIA",
  "RED TEAM",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-white/[0.03] py-6"
      data-testid="marquee"
    >
      <div className="animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <span
            key={i}
            className="mx-6 inline-flex items-center gap-6 font-mono-tech text-sm uppercase tracking-[0.2em] text-white/50"
          >
            {t}
            <span className="text-cyber-cyan">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
